import React from 'react'
import { CellRenderer, CellProps } from '../../legacy-design-system/grid'
import { Application } from './shared'
import { ApplicationRowActionList } from './actions'
import { css } from '@emotion/css'

const actionContainerCss = css`
  margin-left: auto;
  margin-right: 10px;
`
export function getRowActionsCellRenderer({
  organizationID,
  isFreemiumOrganization,
  restrictedEditRole,
  refresh,
  refetchQueries
}): CellRenderer<Application> {
  return function rowActionsCellRenderer({
    rowData,
    getCellContentProps,
    allSelected,
    selectedCount
  }: CellProps<Application> & {
    readonly allSelected: boolean
    readonly selectedCount: number
  }) {
    const someSelected = allSelected || !!selectedCount
    return (
      <div
        {...getCellContentProps({
          className: actionContainerCss
        })}
      >
        {!someSelected && (
          <ApplicationRowActionList
            application={rowData}
            organizationID={organizationID}
            isFreemium={isFreemiumOrganization}
            restrictedEditRole={restrictedEditRole}
            refresh={refresh}
            refetchQueries={refetchQueries}
          />
        )}
      </div>
    )
  }
}
